<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-03 08:49:45
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2024-01-05 09:56:06
 * @FilePath: \community-backendf:\community-frontend\src\components\web\recommendedCard.vue
 * @Description: 推荐卡片
-->

<template>
  <router-link @click="clickRecommendedCard" class="recommended" :to="threadRoute" v-if="props?.recommendedData" ref="cardRef">
    <!-- 推荐图 -->
    <div class="recommended-image">
      <ObImg 
        :src="recommendedData.image" 
        :lazy="true"
        :duration="0"
      />
      <!-- 圈子tag -->
      <router-link v-if="circleInfo" class="circle-tag" :to="circleRoute">
        {{circleInfo?.name}}
      </router-link>
    </div>
    <!-- 推荐帖子名 -->
    <p class="recommended-title">{{props.recommendedData.title}}</p>
    <div class="recommended-info">
      <!-- 用户头像 -->
      <Avatar
        :avatarInfo="avatarInfo"
        :size="isWeb ? 32 : 20"
        :iconSize="isWeb ? 11 : 9"
      >
        <!-- 昵称 -->
        <span class="recommended-author-name">{{authorName}}</span>
      </Avatar>
      <span v-if="!props.showAction" class="recommended-date">{{$formatTime(props.recommendedData.threadCtime, 7)}}</span>
      <!-- 互动按钮 -->
      <div class="action" v-else>
        <div>
          <Like 
            :uid="avatarInfo.uid"
            :id="threadId" 
            :count="threadStat.praiseCount" 
            :status="praised"
            @update:count="updateCount"
            @update:status="updateStatus"
          />
          <span>{{$numFormat(threadStat.praiseCount)}}</span>
        </div>
        <div>
          <svg-icon name="icon-msg" />
          <span>{{$numFormat(threadStat.commentCount)}}</span>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script setup>
import Avatar from '@/components/avatar'
import Like from '@/components/like'
import { ref, getCurrentInstance, onMounted } from 'vue';

import { useSystemStore } from '@/stores/system'
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { nextTick } from 'vue';

const route = useRoute()
const { proxy } = getCurrentInstance()

const systemStore = useSystemStore()

const { isWeb } = storeToRefs(systemStore)

/**
 * @value {ahthourAvatar: 头像，authorIcon：图标，authorId：用户id}
 * @showAction 是否显示互动项
 */  
const props = defineProps({
  recommendedData: {
    type: Object,
    default: null
  },
  showAction: {
    type: Boolean,
    default: false
  },
  index: {
    type: Number,
    default: 1
  }
})

const cardRef = ref()

let { authorAvatar: avatar, authorIcon: icon, authorId: id, authorName, threadId,  circleInfo } = props.recommendedData
// 头像
const avatarInfo = {
  avatar,
  icon,
  id
}

// 帖子路由
const threadRoute = {
  name: 'thread',
  params: {
    id: threadId
  }
}
// 圈子路由
const circleRoute = {
  name: 'circle',
  params: {
    id: circleInfo?.id
  }
}

const praised = ref(props.recommendedData.praised)
const threadStat = ref(props.recommendedData.threadStat)

// 更新点赞数
const updateCount = (count) => {
  threadStat.value.praiseCount = count
}
// 更新点赞状态
const updateStatus = (status) => {
  praised.value = status
}

const clickRecommendedCard = () => {
  proxy.$ga('recommended_thread_entry', {
    "screen_name": route.name,
    "destination": props.recommendedData.webLink,
    "position": props.index
  })
}

onMounted(() => {
  nextTick(() => {
    try {
      let io = new IntersectionObserver((a,b) => {
        if (a[0].intersectionRatio > 0) {
          // 推荐帖子曝光 埋点
          proxy.$ga('recommended_thread_impression', {
            "screen_name": route.name,
            "destination": props.recommendedData.webLink,
            "position": props.index
          })
          io.unobserve(document.querySelectorAll('.recommended')[props.index - 1]);
        }
      });
      io.observe(document.querySelectorAll('.recommended')[props.index - 1])
    } catch (error) {}
  })
})

</script>

<style lang="postcss" scoped>
.recommended {
  &:hover {
    color: unset;
  }
  display: inline-flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  width: 384px; 
  margin: 0 24px 24px 0;
  background-color: #FFF;
  border-radius: var(--recommend-radius);
  overflow: hidden;
  &:nth-child(3n){ 
    margin-right: 0;
  }
  &:nth-child(n + 4) {
    margin-bottom: 0;
  }
  &-image {
    position: relative;
    width: 100%;
    height: 216px;
    :deep(.ob-image) {
      width: 100%;
      height: 100%;
      border-radius: var(--recommend-radius) var(--recommend-radius) 0 0;
    }
    .circle-tag {
      position: absolute;
      right: 0;
      bottom: 0;
      padding: 8px;
      font-size: 12px;
      color: #FFF;
      background-color: var(--mask);
      border-radius: var(--recommend-radius) 0 0 0;
    }
  }
  &-title {
    display: -webkit-box;
    height: 48px;
    margin: 16px 16px 0;
    font-size: 18px;
    word-break: break-word;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  &-info {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px 0;
    :deep(.avatar) {
      margin-left: 16px;
    }
    a:hover {
      color: unset;
    }
    .action {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      margin-right: 16px;
      div:first-child {
        margin-right: 12px;
      }
      div {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;
        
        span {
          font-size: 14px;
          color: var(--text-secondary);
        }
        .svg-icon {
          width: 24px;
          height: 24px;
          margin-right: 4px;
          color: var(--text-secondary);
        }
      }
    }
  }
  &-author-name {
    font-size: 16px;
    margin-left: 8px;
    height: 24px;
    line-height: 24px;
    word-break: break-all;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &-date {
    flex-shrink: 1;
    font-size: 14px;
    color: var(--text-hint);
    margin-right: 16px;
  }

}

@media screen and (max-width: 1023px) {
  .recommended {
    flex-shrink: 0;
    width: 192px;
    font-size: 14px;
    background-color: transparent;
    margin: 0 8px 30px 0;
    &:nth-child(3n){ 
      margin-right: 12px;
    }
    &:nth-child(n + 4) {
      margin-bottom: unset;
    }
    &:last-child {
      margin-right: -20px;
      padding-right:20px;
    }
    &-image {
      width: 192px;
      height: 108px;
      :deep(.ob-image) {
        width: 100%;
        height: 100%;
        border-radius: var(--recommend-radius);
      }
    }
    .circle-tag {
      right: 4px;
      bottom: 4px;
      padding: 4px 6px;
      font-size: 10px;
      background-color: var(--background-hint);
      border-radius: 2px;
    }
    &-title {
      height:auto;
      height:40px;
      font-size: 14px;
      margin: 8px 0;
      line-height: 20px !important;
    }
    &-info {
      padding:0;
      :deep(.avatar) {
        margin: 0;
        .avatar-icon {
          display:none;
        }
      }
    }
    &-author-name {
      height:20px;
      line-height:20px!important;
      font-size: 12px;
    }
    &-date {
      height:20px;
      line-height:20px!important;
      font-size: 10px;
      margin-right:8px;
      color: var(--text-disabled);
    }
  }
}
</style>

<style lang="postcss">
@media screen and (min-width: 1023px) {
  .oneplus {
    .recommended {
      &-title {
        height: 54px;
      }
    }
  }
}

</style>